import { paymentAssetUrl } from '../deposit/helpers.js';
import { API_SITE, SESSION_KEY, apiBase, accessToken } from '../turnover/helpers.js';
import { dedupeAccountFetch } from '../boot/accountCatalogCache.js';

export { API_SITE, SESSION_KEY, apiBase, accessToken };

export function formatVipMoney(value) {
  return `৳${Number(value || 0).toFixed(2)}`;
}

export function resolveVipIconUrl(iconUrl) {
  const value = String(iconUrl || '').trim();
  if (!value) return '';
  return paymentAssetUrl(value) || value;
}

export async function fetchVipSnapshot(opts = {}) {
  return dedupeAccountFetch('GET:/vip', async () => {
    const token = accessToken();
    const res = await fetch(`${apiBase()}/vip`, {
      headers: {
        Accept: 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      cache: 'no-store',
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok) {
      const err = new Error(json.message || json.error || `Request failed (${res.status})`);
      err.status = res.status;
      throw err;
    }
    return json.data || json;
  }).then((data) => {
    if (opts.signal && opts.signal.aborted) {
      const err = new Error('AbortError');
      err.name = 'AbortError';
      throw err;
    }
    return data;
  });
}

export async function claimVipReward(rewardId) {
  const token = accessToken();
  const res = await fetch(`${apiBase()}/vip/rewards/${encodeURIComponent(rewardId)}/claim`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    cache: 'no-store',
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(json.message || json.error || `Request failed (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return json.data || json;
}

export function emptyVipSnapshot() {
  return {
    rankId: 'vip_0',
    rankName: 'Normal / Member',
    rankLevel: 0,
    iconUrl: '',
    percent: 0,
    remaining: 0,
    atMaxRank: false,
    currentTier: { level: 0, label: 'Normal / Member', required: 0, rewards: [], benefits: [] },
    nextTier: null,
    nextRank: null,
    rankList: [],
    depositProgress: { current: 0, required: 0, remaining: 0, percent: 0, visible: false },
    turnoverProgress: { current: 0, required: 0, remaining: 0, percent: 0, visible: false },
    overallProgress: { percent: 0, remaining: 0, rule: 'deposit_and_turnover' },
    progressNote: null,
    claimedRewards: [],
  };
}
